import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Activity } from "@modules/activities/types";
import { ActivityFormValues } from "@modules/activities/validations";
import { editActivityService } from "./service";
import { UseEditActivityMutationOptions } from "./types";

export function useEditActivityMutation(
  options?: UseEditActivityMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Activity, ApiError, { id: string; data: ActivityFormValues }>({
    mutationFn: ({ id, data }) => editActivityService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("agreement_activitys.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
